import { LuPackageX, LuRefreshCw, LuSearchX, LuWifiOff, LuAlertCircle } from "react-icons/lu";

const Skel = ({ w = "100%", h = 14, r, style }) => (
  <div className="ep-skel" style={{ width: w, height: h, borderRadius: r, ...style }} />
);

export function ProductCardSkeleton() {
  return (
    <div className="ep-card" aria-hidden="true" style={{ cursor: "default" }}>
      <div className="ep-card-media">
        <Skel h={130} r={10} />
      </div>
      <div className="ep-card-body">
        <Skel w="60%" h={18} />
        <Skel w="40%" h={14} />
        <Skel h={30} r={8} />
        <Skel h={40} r={8} />
      </div>
      <div className="ep-card-score">
        <Skel w={110} h={40} r={20} />
      </div>
      <div className="ep-card-foot">
        <Skel w={70} h={22} />
        <Skel w={108} h={40} r={8} />
      </div>
    </div>
  );
}

export function ListSkeleton({ count = 6 }) {
  return (
    <div className="ep-list" role="status" aria-label="Loading products">
      {Array.from({ length: count }, (_, i) => (
        <ProductCardSkeleton key={i} />
      ))}
    </div>
  );
}

export function DetailSkeleton() {
  return (
    <div role="status" aria-label="Loading product">
      <div className="ep-detail-media">
        <Skel h="100%" r={0} />
      </div>
      <div className="ep-detail-body">
        <Skel w="70%" h={30} />
        <Skel w="55%" h={16} />
        <Skel h={56} r={10} />
        <div className="ep-summary-grid">
          {[0, 1, 2, 3].map((i) => (
            <Skel key={i} h={88} r={10} />
          ))}
        </div>
        <Skel h={50} r={10} />
        <Skel h={56} r={10} />
      </div>
    </div>
  );
}

export function NutritionSkeleton() {
  return (
    <div className="ep-nutrition" role="status" aria-label="Loading nutrition information">
      <Skel h={88} r={16} />
      <Skel h={140} r={20} />
      <div className="ep-facts-box">
        {Array.from({ length: 8 }, (_, i) => (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0" }}>
            <Skel w="40%" h={14} />
            <Skel w="18%" h={14} />
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Failure screen with Retry. `error.status` (from ShopService) picks the
 * message: 0 = offline / server down, 404 = not found.
 */
export function ErrorState({ error, onRetry, title = "Unable to load product information", notFoundTitle = "Product not found", action }) {
  const offline = error?.status === 0;
  const notFound = error?.status === 404;
  const Icon = offline ? LuWifiOff : notFound ? LuPackageX : LuAlertCircle;
  return (
    <div className="ep-state" role="alert">
      <Icon aria-hidden="true" />
      <h2>{offline ? "You're offline" : notFound ? notFoundTitle : title}</h2>
      <p>{offline ? "Check your internet connection and try again." : error?.message}</p>
      {!notFound && onRetry && (
        <button type="button" className="ep-btn" onClick={onRetry}>
          <LuRefreshCw aria-hidden="true" /> Retry
        </button>
      )}
      {action}
    </div>
  );
}

export function EmptyState({ title, message, action }) {
  return (
    <div className="ep-state">
      <LuSearchX aria-hidden="true" />
      <h2>{title}</h2>
      {message && <p>{message}</p>}
      {action}
    </div>
  );
}
